import React from 'react';
import { useForm } from '@inertiajs/react';
import SubmitButton from '../../../components/form/SubmitButton';
import FormError from '../../../components/form/FormError';
import { useTrans } from '../../../hooks/useTrans';
import { trackAndTraceUrl } from '../../../lib/routes';

export default function SubscribeForm({ traceUuid, fromOrderId, email }) {
    const translate = useTrans();
    const { data, setData, post, processing, errors } = useForm({ email: email ?? '' });

    const submit = (event) => {
        event.preventDefault();
        post(trackAndTraceUrl(traceUuid, { fromOrderId }), { preserveScroll: true });
    };

    return (
        <>
            <h3 className="order-heading">{translate('Aanmelden voor Track & Trace updates')}</h3>
            <p>{translate('Voer hier uw e-mailadres in als u een update wenst te ontvangen bij de volgende statusupdate van uw transport.')}</p>

            <form onSubmit={submit}>
                <div className="form-item form-item--flex form-item--track-and-trace">
                    <div className="form-item form-item--inline">
                        <input
                            className="form-item__input"
                            type="email"
                            name="email"
                            required
                            placeholder={translate('E-mailadres')}
                            value={data.email}
                            onChange={(event) => setData('email', event.target.value)}
                        />
                        <FormError message={errors.email} />
                    </div>

                    <SubmitButton title={translate('Aanmelden')} disabled={processing} />
                </div>
            </form>
        </>
    );
}
